import * as React from 'react';
import s from './Enterprise.scss';
import { FormLayout } from '../../../components/RequestCall/lazy/Form/FormLayout';
import { SideTitle } from './SideTitle';

interface EnterpriseFormProps {
  showSuccsessMessage(s: boolean): void;
}

const formInputLabels = {
  firstName: 'enterprise_plans.request_a_call.field.first_name',
  lastName: 'enterprise_plans.request_a_call.field.last_name',
  bussinessEmail: 'enterprise_plans.request_a_call.field.business_email',
  phoneNumber: 'enterprise_plans.request_a_call.field.phone',
  company: 'enterprise_plans.request_a_call.field.company',
  jobTitle: 'enterprise_plans.request_a_call.field.job_title',
  messageBox: 'enterprise_plans.request_a_call.field.tell_us_more',
};

export const EnterpriseForm: React.FC<EnterpriseFormProps> = ({
  showSuccsessMessage,
}) => {
  return (
    <div className={s.formSection}>
      <SideTitle
        titleKey='enterprise_plans.request_a_call.title'
        subtitleKey='enterprise_plans.request_a_call.subtitle'
      />
      <div className={s.formContainer}>
        <FormLayout
          onCancelClick={() => {}}
          showSuccsessMessage={showSuccsessMessage}
          formInputLabels={formInputLabels}
          labelSize='medium'
          inputSize='large'
          disclaimerKey='enterprise_plans.request_a_call.disclaimer.text'
          hideCancel
        />
      </div>
    </div>
  );
};
